import { render, staticRenderFns } from "./VAutocompleteCompany.vue?vue&type=template&id=2a136f02&scoped=true"
import script from "./VAutocompleteCompany.vue?vue&type=script&lang=js"
export * from "./VAutocompleteCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a136f02",
  null
  
)

export default component.exports